export default __webpack_public_path__ + "static/media/homepageImage.92862d7f.png";